import { createRoute } from "@tanstack/react-router";
import WebsiteLayout from "../../components/layouts/website/WebsiteLayout";
import {
  rootRoute
} from "../index";
import SpinnerFullscreen from "../../components/general/SpinnerFullscreen";


export const websiteRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: "websiteLayout",
  component: WebsiteLayout,
  pendingComponent: SpinnerFullscreen,
});

export const homeRoute = createRoute({
  getParentRoute: () => websiteRoute,
  path: "/",
}).lazy(() => import("./index.lazy").then((d) => d.HomeRoute));

export const facebookPrivacyPolicyRoute = createRoute({
  getParentRoute: () => websiteRoute,
  path: "facebook-privacy-policy",
}).lazy(() => import("./index.lazy").then((d) => d.FacebookPrivacyPolicyRoute));

export const privacyPolicyRoute = createRoute({
  getParentRoute: () => websiteRoute,
  path: "privacy-policy",
}).lazy(() => import("./index.lazy").then((d) => d.PrivacyPolicyRoute));

export const termsOfServiceRoute = createRoute({
  getParentRoute: () => websiteRoute,
  path: "terms-of-service",
}).lazy(() => import("./index.lazy").then((d) => d.TermsOfServiceRoute));

export const cookiePolicyRoute = createRoute({
  getParentRoute: () => websiteRoute,
  path: "cookie-policy",
}).lazy(() => import("./index.lazy").then((d) => d.CookiePolicyRoute)); 